/**
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */

import VERTC from '@volcengine/rtc';
import { Select, Tooltip, Typography } from '@arco-design/web-react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/store';
import Operation from './components/Operation';
import { updateScene } from '@/store/slices/room';
import TopActions from '../MainArea/Room/TopActions';
import packageJson from '../../../../package.json';
import styles from './index.module.less';

function Menu() {
  const dispatch = useDispatch();
  const room = useSelector((state: RootState) => state.room);
  const isJoined = room?.isJoined;
  const requestId = sessionStorage.getItem('RequestID');
  const scenes = Object.values(room.sceneConfigMap || {});
  const currentSceneName = room.sceneConfigMap?.[room.scene]?.name || room.scene || '-';

  return (
    <div className={styles.wrapper}>
      <div className={styles.section}>
        <div className={styles.title}>场景切换</div>
        <Select
          placeholder="选择场景"
          value={room.scene}
          size="small"
          onChange={(value) => dispatch(updateScene(String(value)))}
        >
          {scenes.map((item) => (
            <Select.Option key={item.id} value={item.id}>
              {item.name || item.id}
            </Select.Option>
          ))}
        </Select>
        <div className={styles.hint}>当前人设：{currentSceneName}</div>
      </div>

      {isJoined ? (
        <div className={styles.section}>
          <div className={styles.title}>快捷操作</div>
          <TopActions inPanel />
        </div>
      ) : null}

      {isJoined ? <Operation /> : ''}

      <div className={styles.section}>
        <div className={styles.title}>{isJoined ? '其他信息' : '版本信息'}</div>
        <div className={styles.desc}>Demo Version {packageJson.version}</div>
        <div className={styles.desc}>SDK Version {VERTC.getSdkVersion()}</div>
        {isJoined ? (
          <div className={styles.desc}>
            房间ID{' '}
            <Tooltip content={room.roomId || '-'}>
              <Typography.Paragraph
                ellipsis={{
                  rows: 1,
                  expandable: false,
                }}
                className={styles.value}
              >
                {room.roomId || '-'}
              </Typography.Paragraph>
            </Tooltip>
          </div>
        ) : (
          ''
        )}
        {room.isAIGCEnable ? (
          <div className={styles.desc}>
            RequestID{' '}
            <Tooltip content={requestId || '-'}>
              <Typography.Paragraph
                ellipsis={{
                  rows: 1,
                  expandable: false,
                }}
                className={styles.value}
              >
                {requestId || '-'}
              </Typography.Paragraph>
            </Tooltip>
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  );
}

export default Menu;
